<template>
<div class="chapter">
<div class="inner_page">
<p class="C124"><strong><a id="page_vii">CONTENTS</a></strong></p><a id="page_vii">
</a><p class="C134"><a id="page_vii"></a><a href="#/xhtml/06_ACKNOWLEDGMENTS#page_ix">ACKNOWLEDGMENTS</a></p>
<p class="C135"><a href="#/xhtml/07_ABBREVIATIONS#page_xiii">ABBREVIATIONS</a></p>
<p class="C134"><a href="#/xhtml/08_INTRODUCTION#page_1">INTRODUCTION</a></p>
<p class="C134"><a href="#/xhtml/09_CHAPTER_1__Farm_Worker_Organizin#page_15">CHAPTER 1. Farm Worker Organizing and the Advent of the UFW: 1900 to 1993</a></p>
<p class="C134"><span href="#/xhtml/10_CHAPTER_2__Dolores_Huerta_s_Life#page_31" title="Link target outside of Sample">CHAPTER 2. Dolores Huerta’s Life: Intersectional Habitus as Rhetorical Agency</span></p>
<p class="C134"><span href="#/xhtml/11_CHAPTER_3__Letters_to_C_sar_Ch_v#page_50" title="Link target outside of Sample">CHAPTER 3. Letters to César Chávez: Building Collaborative Agency</span></p>
<p class="C134"><span href="#/xhtml/12_CHAPTER_4__Motherhood__Familia#page_77" title="Link target outside of Sample">CHAPTER 4. Motherhood, Familia, Emotionality: Strategic Use of Gendered Public Persona</span></p>
<p class="C134"><span href="#/xhtml/13_CHAPTER_5__Public_Persona_of_Dif#page_106" title="Link target outside of Sample">CHAPTER 5. Public Persona of Differential Bravery through Collaborative Egalitarianism and Courageous Optimism</span></p>
<p class="C135"><span href="#/xhtml/14_CHAPTER_6__Dolores_Huerta__Iconi#page_134" title="Link target outside of Sample">CHAPTER 6. Dolores Huerta, Iconicity, and Social Movements</span></p>
<p class="C134"><span href="#/xhtml/15_EPILOGUE#page_154" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="C134"><span href="#/xhtml/16_REFERENCES#page_164" title="Link target outside of Sample">REFERENCES</span></p>
<p class="C134"><span href="#/xhtml/17_INDEX#page_179" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?74e62582